export default __webpack_public_path__ + "static/media/cw-4.9635bd01.png";